const UserSvg = ({ size = 8 }) => (
  <svg
    viewBox="0 0 17 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={` size-${size}`}
  >
    <path
      d="M11.9989 4.5C11.9989 6.57107 10.3199 8.25 8.24886 8.25C6.1778 8.25 4.49886 6.57107 4.49886 4.5C4.49886 2.42893 6.1778 0.75 8.24886 0.75C10.3199 0.75 11.9989 2.42893 11.9989 4.5Z"
      stroke="var(--primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.75 18.6182C0.820305 14.5369 4.15074 11.25 8.24886 11.25C12.3471 11.25 15.6776 14.5371 15.7477 18.6185C13.4649 19.666 10.9253 20.25 8.24918 20.25C5.57286 20.25 3.03296 19.6659 0.75 18.6182Z"
      stroke="var(--primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserSvg;
